module.exports = "<svg viewBox=\"0 0 299.2 110\"><path d=\"M33.6 0C15.1 0 0 15.1 0 33.6h18.9c0-8.1 6.6-14.7 14.7-14.7s14.7 6.6 14.7 14.7-6.6 14.7-14.7 14.7h-9.4V75H43v-9.2c17.8-5.2 28-23.9 22.8-41.7C61.6 9.9 48.5 0 33.6 0z\" class=\"st0\"></path><path d=\"M33.6 83.2c5.3 0 9.5 4.3 9.5 9.6s-4.3 9.6-9.5 9.6-9.6-4.3-9.6-9.6 4.3-9.6 9.6-9.6z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-teacher.svg
// module id = 293
// module chunks = 1